import { render, staticRenderFns } from "./sss_yc_mx.vue?vue&type=template&id=589d44f0&scoped=true"
import script from "./sss_yc_mx.vue?vue&type=script&lang=js"
export * from "./sss_yc_mx.vue?vue&type=script&lang=js"
import style0 from "./sss_yc_mx.vue?vue&type=style&index=0&id=589d44f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "589d44f0",
  null
  
)

export default component.exports